import AnalyticsHandler from './handler.js'
import { DEFAULT_PAYLOAD } from '@/lib/analytics/consts.js'
import { getBaseProperties } from '@/lib/analytics/helpers.js'
import { useWebViewEventBus } from '@/composables/web-view-event-bus'

export default class WebViewHandler extends AnalyticsHandler {
  __initialize () {
    const name = this.config.name

    if (!name) {
      this.error('config.name not set')
      return true // do not retry
    }

    return super.__initialize() // done
  }

  send (event) {
    useWebViewEventBus().events.analyticsEvent(event)

    this.debug(`${this.config.name} sent:`, { event })
  }

  [DEFAULT_PAYLOAD] (data) {
    const baseProperties = getBaseProperties(data)

    return {
      properties: baseProperties,
    }
  }
}
